// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__58qtq"};